import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../sidebar/sidebar.css";
import { userLogout } from "../../hooks/api/utils";
import { useSelector } from "react-redux";

const Sidebar = ({ isOpen }) => {
  const navigate = useNavigate();
    const first_name = useSelector((state) => state?.auth?.user?.first_name);

  const handleLogout = () => {
    userLogout(navigate, '/'); 
  };

  return (
    <aside className={`${isOpen ? "open" : ""}`}>
      <div className="profileName">
        {/* <div className="profImg">
          <img
            src="/images/profile-sample.svg"
            className="img-fluid"
            alt="Profile"
          />
        </div> */}
        <h5>Hello, {first_name}!</h5>
      </div>

      <nav className="mt-2">
        <ul>
          <li>
            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/dashboardIcon.svg"
                alt="Dashboard"
                className="img-fluid"
              />
              <span>Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/users"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/userIcon.svg"
                alt="User Management"
                className="img-fluid"
              />
              <span>User Management</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={"/industry"} className={({ isActive }) => (isActive ? "active" : "")}>
              <img
                src="../images/serviceIcon.svg"
                alt="icon"
                className="img-fluid"
              />
              <span>Industry Management</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/vendors"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="../images/managementIcon.svg"
                alt="icon"
                className="img-fluid"
              />
              <span>Vendor Management</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/services"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/serviceIcon.svg"
                alt="Service Management"
                className="img-fluid"
              />
              <span>Service Management</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/vendor-services"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/chatBotIcon.svg"
                alt="Chat Bot"
                className="img-fluid"
              />
              <span>Vendor Services</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/orders"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/orderIcon.svg"
                alt="Orders"
                className="img-fluid"
              />
              <span>Order Management</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/country-control"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/countryIcon.svg"
                alt="Country Control"
                className="img-fluid"
              />
              <span>Country based control</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/chatbot-configuration"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/chatbot.svg"
                alt="Country Control"
                className="img-fluid"
              />
              <span>Chatbot Configuration</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/vegetation-type"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <img
                src="/images/vegetationType.svg"
                alt="Country Control"
                className="img-fluid"
              />
              <span>Vegetation Types</span>
            </NavLink>
          </li>
          <hr />

          <li>
            <NavLink
              to="/setting"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
                <img
                src="/images/settingIcon.svg"
                alt="Country Control"
                className="img-fluid"
              />
              <span>Settings</span>
            </NavLink>
          </li>
        </ul>
      </nav>

      <nav className="mt-2">
        <ul>
             <li>
          <button className="logout-btn" onClick={handleLogout}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={22} height={22} fill="none">
            <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z" fill="#ffffff"/></svg>
            <span>Log Out</span>
          </button>
        </li>
            
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
